"use client";

import { usePathname } from "next/navigation";
import { useMemo } from "react";

const useEventSchema = (events: ServiceEvent[] = []) => {
  const pathname = usePathname();
  const eventSchema = useMemo(() => {
    const result = events.map((item) => {
      return {
        "@context": "https://schema.org",
        "@type": "EducationEvent",
        name: item.eventName || item.serviceName,

        startDate: item.startDate,
        endDate: item.endDate,
        eventStatus: "https://schema.org/EventScheduled",
        location: {
          "@type": "Place",
          name: "Spoclearn",
          address: {
            "@type": "PostalAddress",
            streetAddress:
              "3500 S Dupont Hwy Suite DK 101, Dover, DE 19901, United States",
            addressLocality: "Dover",
            postalCode: "19901",
            addressRegion: "PA",
            addressCountry: "US",
          },
        },
        image: [process.env.NEXT_PUBLIC_APP_URL + "/images/logo.svg"],
        description: item.eventDescription || item.serviceEventTitle,
        offers: {
          "@type": "AggregateOffer",
          lowPrice: item.eventDetail.price,
          highPrice: item.eventDetail.price,
          url: process.env.NEXT_PUBLIC_APP_URL + pathname,
          availability: "https://schema.org/InStock",
          validFrom: item.startDate,
          price: item.eventDetail.price,
          priceCurrency: item.eventDetail.currency,
        },
        performer: {
          "@type": "PerformingGroup",
          name: "Spoclearn",
        },
        organizer: {
          "@type": "Organization",
          name: "Spoclearn",
          url: process.env.NEXT_PUBLIC_APP_URL,
        },
      };
    });
    return result;
  }, [events, pathname]);

  return eventSchema;
};

export default useEventSchema;
